import { Routes, ɵEmptyOutletComponent } from '@angular/router';
import { simpleNoIndexMetaResolver } from './account/resolves/simple-no-index-meta-resolver';
import { growthBookGuard } from './guards/growth-book.guard';
import { NotFoundGuard } from './guards/not-found.guard';
import { TenantAuthGuard } from './guards/tenant-auth.guard';

const allRoutes: Routes = [
  {
    path: 'folder',
    loadChildren: () => import('./view-folder/routes').then(m => m.routes),
    data: { meta: simpleNoIndexMetaResolver },
  },
  {
    path: '',
    loadChildren: () => import('./view-gallery/routes').then(m => m.routes),
  },
  {
    path: 'auth/**',
    component: ɵEmptyOutletComponent,
    canActivate: [TenantAuthGuard],
  },
  {
    path: '**',
    canActivate: [NotFoundGuard],
    loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
    data: { meta: simpleNoIndexMetaResolver },
  },
];

export const tenantRoutes: Routes = [
  {
    path: '',
    children: allRoutes,
    runGuardsAndResolvers: 'always',
    canActivate: [growthBookGuard],
    data: {
      meta: {
        tags: [
          {
            name: 'viewport',
            content:
              'width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, user-scalable=no, shrink-to-fit=no',
          },
        ],
      },
    },
  },
];
